<script setup lang="ts">
import { ref } from 'vue'
import HelpButton from '@/components/common/help/HelpButton.vue'
import { useContextualHelp } from '@/composables/useContextualHelp'

interface Props {
  isOpen: boolean
}

const props = defineProps<Props>()

const emit = defineEmits<{
  close: []
  resolve: [comment: string]
}>()

// Aide contextuelle (USER_MASTER) — active uniquement quand la modale est
// ouverte ; surcharge l'aide de la page puis la restaure à la fermeture.
useContextualHelp('ticket-resolve', () => props.isOpen)

const comment = ref('')
const loading = ref(false)

function handleClose() {
  comment.value = ''
  emit('close')
}

async function handleResolve() {
  if (!comment.value.trim()) return
  loading.value = true
  try {
    emit('resolve', comment.value)
    comment.value = ''
  } finally {
    loading.value = false
  }
}
</script>

<template>
  <dialog class="modal" :class="{ 'modal-open': isOpen }">
    <div class="modal-box">
      <div class="flex items-center gap-1">
        <h3 class="text-lg font-bold">Résoudre le ticket</h3>
        <HelpButton />
      </div>
      <p class="py-4 text-sm text-gray-600">
        Veuillez saisir un commentaire de résolution pour fermer ce ticket.
      </p>

      <div class="space-y-4">
        <div class="w-full">
          <label for="resolve-comment" class="block text-sm font-medium text-gray-700 mb-1">Commentaire de résolution *</label>
          <textarea
            id="resolve-comment"
            v-model="comment"
            class="textarea textarea-bordered w-full h-32"
            placeholder="Expliquez comment le ticket a été résolu..."
            :disabled="loading"
          />
        </div>
      </div>

      <div class="modal-action">
        <button
          class="btn"
          @click="handleClose"
          :disabled="loading"
        >Annuler</button>

        <button
          class="btn btn-primary"
          @click="handleResolve"
          :disabled="!comment.trim() || loading"
        >Confirmer la résolution</button>
      </div>
    </div>
    <form method="dialog" class="modal-backdrop">
      <button @click="handleClose">close</button>
    </form>
  </dialog>
</template>
